import { DynamicSchema } from '@soniq/schema'
import { definitions } from '../../.types/ContactRelationship.schema.json'
import type { ContactRelationshipSchema } from '../../.types/ContactRelationship.schema'

export type { ContactRelationshipSchema } from '../../.types/ContactRelationship.schema'
export const contactRelationshipJsonSchema = {
  ...definitions.ContactRelationshipSchema,
  definitions,
}

export const contactRelationshipSchema =
  DynamicSchema.new<ContactRelationshipSchema>({
    id: 'ContactRelationshipSchema',
    jsonSchema: contactRelationshipJsonSchema,
  })

export * from './guards'
export * from './validation'
export * from './types'
